import { compose } from 'redux';
import { connect } from 'react-redux';
import { GlobalState } from 'ha/types/store';

import { getListingsCounts } from '../selectors';
import { TopCities } from '../components/TopCities';

const enhance = compose(
  connect((state: GlobalState) => ({
    listingsCounts: getListingsCounts(state),
  })),
);

const TopCitiesContainer = enhance(TopCities);
export { TopCitiesContainer };
